export const RESOLVE_LOCALE_FROM_URL = "resolve-locale-from-url";
export const RESOLVE_LOCALE_FROM_PROGRAM = "resolve-locale-from-program";
export const RESOLVE_THEME_FROM_URL = "resolve-theme-from-url";
export const RESOLVE_THEME_FROM_PROGRAM = "resolve-theme-from-program";
export const RESOLVE_CARD_DESIGN_FROM_URL = "resolve-card-design-from-url";
export const UPDATE_CHECKOUT_SETTINGS = "update-checkout-settings";
export const RESOLVE_THEME_FROM_SETTINGS = "resolve-theme-from-settings";
export const RESOLVE_DESIGN_MODE_FROM_URL = "resolve-design-mode-from-url";
export const SET_SHOPIFY_MODE = "set-shopify-mode";
export const UPDATE_SHOPIFY_MODE_SETTINGS = "update-shopify-mode-settings";
export const RESOLVE_CUSTOM_SETTINGS_FROM_URL = "resolve-custom-settings-from-url";
